<template>
  <div class="blog-home blog-page-container" :style="backgroundStyle">
    <!-- 背景图层 -->
    <div class="background-layer" :style="backgroundLayerStyle"></div>
    
    <!-- 移除原有的移动端导航切换按钮 -->
    
    <div class="mobile-nav-menu" :class="{ active: mobileNavActive }">
      <div class="mobile-nav-header">
        <div class="mobile-blogger-info">
          <div class="mobile-blogger-avatar">
            <img src="@/assets/images/blog/head.png" alt="博主头像" />
          </div>
          <div class="mobile-blogger-details">
            <h3 class="mobile-blogger-name">{{ bloggerInfo.name }}</h3>
            <p class="mobile-blogger-bio">{{ bloggerInfo.bio }}</p>
          </div>
        </div>
        <div class="mobile-contact-icons">
          <el-tooltip content="邮箱" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip content="GitHub" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.115 2.504.337 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip content="QQ" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                <path d="M21.395 15.035a40 40 0 0 0-.803-2.264l-1.079-2.695c.001-.032.014-.562.014-.836C19.526 4.632 17.351 0 12 0S4.474 4.632 4.474 9.241c0 .274.013.804.014.836l-1.08 2.695a39 39 0 0 0-.802 2.264c-1.021 3.283-.69 4.643-.438 4.673.54.065 2.103-2.472 2.103-2.472c0 1.469.756 3.387 2.394 4.771-.612.188-1.363.479-1.845.835-.434.32-.379.646-.301.778.343.578 5.883.369 7.482.189 1.6.18 7.14.389 7.483-.189.078-.132.132-.458-.301-.778-.483-.356-1.233-.646-1.846-.836 1.637-1.384 2.393-3.302 2.393-4.771 0 0 1.563 2.537 2.103 2.472.251-.03.581-1.39-.438-4.673"/>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip content="微信" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                <path d="M2.224 21.667s4.24-1.825 4.788-2.056C15.029 23.141 22 17.714 22 11.898 22 6.984 17.523 3 12 3S2 6.984 2 11.898c0 1.86.64 3.585 1.737 5.013-.274.833-1.513 4.756-1.513 4.756zm5.943-9.707c.69 0 1.25-.569 1.25-1.271a1.26 1.26 0 0 0-1.25-1.271c-.69 0-1.25.569-1.25 1.27 0 .703.56 1.272 1.25 1.272zm7.583 0c.69 0 1.25-.569 1.25-1.271a1.26 1.26 0 0 0-1.25-1.271c-.69 0-1.25.569-1.25 1.27 0 .703.56 1.272 1.25 1.272z"/>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip content="B站" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                <path d="M19.5 3.5h-2.38l.94-.94a1.49 1.49 0 0 0 0-2.12a1.51 1.51 0 0 0-2.12 0L12.88 3.5h-1.76L8.06.44a1.51 1.51 0 0 0-2.12 0a1.49 1.49 0 0 0 0 2.12l.94.94H4.5A4.51 4.51 0 0 0 0 8v10a4.51 4.51 0 0 0 4.5 4.5H5a1.75 1.75 0 0 0 3.46 0h7a1.75 1.75 0 0 0 3.46 0h.52A4.51 4.51 0 0 0 24 18V8a4.51 4.51 0 0 0-4.5-4.5zm1.5 14.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18V8a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5z"/>
                <path d="M15 15.1a.73.73 0 0 0-.87.57a.54.54 0 0 1-.34.08c-.65 0-1-1-1-1a.76.76 0 0 0-.71-.49a.76.76 0 0 0-.7.49s-.4 1-1.05 1c-.23 0-.32-.06-.32 0a.75.75 0 0 0-1.55.25a1.69 1.69 0 0 0 1.79 1.24a2.35 2.35 0 0 0 1.75-.82a2.35 2.35 0 0 0 1.75.83A1.69 1.69 0 0 0 15.54 16a.77.77 0 0 0-.54-.9zm-5.24-4.45a.74.74 0 0 0-.88-.58l-3.94.8a.75.75 0 0 0-.59.89.77.77 0 0 0 .74.6h.15l3.94-.8a.76.76 0 0 0 .58-.91zm9.3.22l-3.94-.8a.74.74 0 0 0-.88.58.76.76 0 0 0 .58.89l3.94.8h.15a.77.77 0 0 0 .74-.6.75.75 0 0 0-.59-.87"/>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip content="知乎" placement="top" :open-delay="300">
            <a class="mobile-contact-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                <path d="M5.721 0C2.251 0 0 2.25 0 5.719V18.28C0 21.751 2.252 24 5.721 24h12.56C21.751 24 24 21.75 24 18.281V5.72C24 2.249 21.75 0 18.281 0zm1.964 4.078q-.408 1.096-.68 2.11h4.587c.545-.006.445 1.168.445 1.171H9.384a58 58 0 0 1-.112 3.797h2.712c.388.023.393 1.251.393 1.266H9.183a9.2 9.2 0 0 1-.408 2.102l.757-.604c.452.456 1.512 1.712 1.906 2.177.473.681.063 2.081.063 2.081l-2.794-3.382c-.653 2.518-1.845 3.607-1.845 3.607-.523.468-1.58.82-2.64.516 2.218-1.73 3.44-3.917 3.667-6.497H4.491c0-.015.197-1.243.806-1.266h2.71c.024-.32.086-3.254.086-3.797H6.598c-.136.406-.158.447-.268.753-.594 1.095-1.603 1.122-1.907 1.155.906-1.821 1.416-3.6 1.591-4.064.425-1.124 1.671-1.125 1.671-1.125M13.078 6h6.377v11.33h-2.573l-2.184 1.373.401-1.373h-1.219zm1.313 1.219v8.86h.623l.263.937 1.455-.938h1.456v-8.86z"/>
              </svg>
            </a>
          </el-tooltip>
        </div>
      </div>

      <div class="mobile-nav-search">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索文章标题或内容"
          prefix-icon="el-icon-search"
          @keyup.enter.native="handleSearch"
          clearable
          size="small"
        ></el-input>
      </div>

      <div class="mobile-nav-tags">
        <div class="mobile-tag-list">
          <el-tag
            :class="{ active: selectedTag === '' }"
            @click="handleFilterTag(''); closeMobileNav()"
            size="mini"
            class="mobile-tag-item"
          >
            全部
          </el-tag>
          <el-tag
            v-for="tag in filteredTags"
            :key="'tag-' + tag"
            :class="{ active: selectedTag === tag }"
            @click="handleFilterTag(tag); closeMobileNav()"
            size="mini"
            class="mobile-tag-item"
          >
            {{ tag }}
          </el-tag>
        </div>
      </div>
    </div>

    <div class="mobile-nav-backdrop" :class="{ active: mobileNavActive }" @click="closeMobileNav"></div>
    
    <!-- 博客头部 -->
    <div class="blog-header" :style="contentCardStyle">
      <div class="blog-header-content">
        <div class="blog-info">
          <h1 class="blog-title">
            <span class="crown-icon">&#128081;</span>
            ziyanlin2013's Blog
          </h1>
          <div class="blog-subtitle">随随便便.点点滴滴</div>
        </div>
        <!-- 右侧按钮组容器，仅PC端显示 -->
        <div class="header-right-buttons" v-if="!isMobile">
          <div class="bg-settings-container">
            <background-settings @background-updated="handleBgSettingsUpdated" />
          </div>
          <!-- 视图切换按钮 -->
          <el-tooltip content="切换视图" placement="top" :enterable="false">
            <el-button
              class="icon-btn view-toggle-btn"
              type="primary"
              size="small"
              circle
              @click="toggleViewMode"
            >
              <i :class="viewMode === 'card' ? 'el-icon-s-grid' : 'el-icon-s-unfold'"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
        
      <!-- 导航按钮区域 -->
      <div class="blog-nav">
        <div class="nav-buttons">
        <el-button 
            :type="selectedType === '' ? 'primary' : 'text'"
            size="small" 
            class="nav-button"
            :class="{'selected-nav-button': selectedType === ''}"
            :style="selectedType === '' ? { '--btn-bg-color': '#409EFF' } : {}"
            @click="handleFilterType('')"
        >
            全部
        </el-button>
          <el-button 
            v-for="type in articleTypes" 
            :key="type.value"
            :type="selectedType === type.value ? 'primary' : 'text'"
            :style="selectedType === type.value ? { 
              backgroundColor: getArticleTypeStyle(type.value), 
              borderColor: getArticleTypeStyle(type.value),
              '--btn-bg-color': getArticleTypeStyle(type.value)
            } : {}"
            size="small"
            class="nav-button"
            :class="{'selected-nav-button': selectedType === type.value}"
            @click="handleFilterType(type.value)"
          >
            {{ type.label }}
          </el-button>
        </div>
      </div>
    </div>
    
    <!-- 移动端分类过滤栏 -->
    <div class="mobile-type-filter" v-if="isMobile" :style="contentCardStyle">
      <div class="mobile-type-filter-scroll">
        <div 
          class="mobile-type-item" 
          :class="{ active: selectedType === '' }"
          @click="handleFilterType('')"
        >
          全部
        </div>
        <div 
          v-for="type in articleTypes" 
          :key="'mobile-' + type.value"
          class="mobile-type-item"
          :class="{ active: selectedType === type.value }"
          :style="selectedType === type.value ? { 
            backgroundColor: getArticleTypeStyle(type.value), 
            borderColor: getArticleTypeStyle(type.value)
          } : {}"
          @click="handleFilterType(type.value)"
        >
          {{ type.label }}
        </div>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="blog-content">
      <!-- 文章卡片瀑布流区域 -->
      <div class="article-cards" v-loading="loading">
        <!-- 卡片视图空状态 -->
        <div v-if="articles.length === 0 && !loading && viewMode === 'card'" class="article-card-container">
          <div class="waterfall">
            <div class="no-data" :style="contentCardStyle">
              <div class="no-data-content">
          <i class="el-icon-document"></i>
                <span class="no-data-title">暂无文章</span>
                <p class="no-data-tips">
                  没有找到符合条件的文章，请尝试调整筛选条件
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 卡片视图 -->
        <div class="article-card-container" v-show="viewMode === 'card'">
          <div class="waterfall">
            <!-- 修改 el-tooltip，添加移动设备检测条件，在移动设备上不显示tooltip -->
            <el-tooltip
              v-for="article in articles"
              :key="article.article_code"
              :content="article.article_name"
              placement="top"
              :enterable="false"
              effect="dark"
              :disabled="isMobile"
            >
              <div
                class="article-card"
                :style="contentCardStyle"
                @click="handleViewArticle(article)"
                :class="{ [`article-card-${getArticleTypeClass(article.article_type)}`]: true }"
              >
                <!-- 文章类型装饰 -->
                <div class="article-type-decoration"></div>

                <!-- 置顶+加密标签容器 -->
                <div class="top-badges">
                  <div v-if="article.is_top" class="top-pill" aria-label="置顶">⇧</div>
                  <div v-if="article.has_password" class="encrypted-pill" aria-label="加密">
                    <i class="el-icon-lock"></i>
                  </div>
                </div>

                <!-- 阅读数气泡 -->
                <div class="read-count-bubble">
                  <i class="el-icon-view"></i>
                  <span>{{ article.read_count > 999 ? '999+' : (article.read_count || 0) }}</span>
                </div>

                <!-- 文章摘要封面（装饰性色条） -->
                <div class="article-cover" :class="'article-cover-' + getArticleTypeClass(article.article_type)"></div>

                <!-- 文章信息 -->
                <div class="article-info">
                  <div class="article-content">
                    <!-- 文章标题行 -->
                    <div class="title-wrap">
                      <h3 class="article-title">{{ article.article_name }}</h3>
                    </div>
                    <!-- 类型+日期行 -->
                    <div class="article-meta">
                      <el-tag
                        :color="getArticleTypeStyle(article.article_type)"
                        effect="dark"
                        size="mini"
                        class="article-type"
                      >
                        {{ article.article_type }}
                      </el-tag>
                      <div class="article-stats">
                        <span class="article-time">
                          <i class="el-icon-date"></i>
                          {{ formatDate(article.create_time) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="article-divider"></div>

                  <div class="article-footer">
                    <div class="article-tags" v-if="article.article_tag && article.article_tag.split(',').filter(tag => tag.trim()).length > 0">
                    <el-tag
                        v-for="tag in article.article_tag.split(',').filter(tag => tag.trim())"
                      :key="tag"
                      size="mini"
                      class="article-tag"
                    >
                      {{ tag }}
                    </el-tag>
                    </div>
                    <div class="article-tags-placeholder" v-else></div>
                    <div class="read-more">
                      <span>阅读全文</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>

        <!-- 列表视图 -->
        <div class="article-list-container" v-show="viewMode === 'list'" v-loading="loading">
          <!-- 暂无文章 -->
          <div v-if="articles.length === 0 && !loading && viewMode === 'list'" class="article-list-empty" :style="contentCardStyle">
            <div class="no-data-content">
              <i class="el-icon-document"></i>
              <span class="no-data-title">暂无文章</span>
              <p class="no-data-tips">
                没有找到符合条件的文章，请尝试调整筛选条件
              </p>
            </div>
          </div>

          <!-- 列表项 -->
          <div
            v-for="article in articles"
            :key="article.article_code"
            class="article-list-item"
            :style="contentCardStyle"
            @click="handleViewArticle(article)"
          >
            <!-- 左侧类型色块 -->
            <div
              class="list-item-type"
              :style="{ backgroundColor: getArticleTypeLightStyle(article.article_type), color: getArticleTypeStyle(article.article_type) }"
            >
              <span class="type-text" :class="{ 'is-english': isEnglishType(article.article_type) }">{{ article.article_type }}</span>
            </div>

            <!-- 右侧内容区 -->
            <div class="list-item-content">
              <!-- 第一行：标题 + 阅读数 -->
              <div class="list-item-row1">
                <h3 class="list-item-title">{{ article.article_name }}</h3>
                <span class="list-item-views">{{ formatReadCount(article.read_count) }} 🔥</span>
              </div>

              <!-- 分隔线 -->
              <div class="list-item-divider"></div>

              <!-- 第二行：置顶/加密 + 标签 + 时间 -->
              <div class="list-item-row2">
                <div class="list-item-left">
                  <span v-if="article.is_top" class="list-item-badge top-badge" title="置顶">⇧</span>
                  <span v-if="article.has_password" class="list-item-badge lock-badge" title="加密">
                    <i class="el-icon-lock"></i>
                  </span>
                  <div class="list-item-tags" v-if="article.article_tag && article.article_tag.split(',').filter(tag => tag.trim()).length > 0">
                    <el-tag
                      v-for="tag in article.article_tag.split(',').filter(tag => tag.trim())"
                      :key="tag"
                      size="mini"
                      class="list-tag"
                    >
                      {{ tag }}
                    </el-tag>
                  </div>
                </div>
                <div class="list-item-right">
                  <span class="list-item-date">{{ formatDate(article.create_time) }}</span>
                </div>
              </div>
            </div>
          </div>

          </div>
        <!-- 加载更多 / 到底提示 -->
        <div v-if="hasMore && !loading && articles.length > 0" class="load-more">
          <el-button type="text" @click="loadMore">加载更多</el-button>
        </div>
        <div v-if="loading && articles.length > 0" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <!-- 到底提示 - 所有视图 -->
        <div v-show="!hasMore && articles.length > 0 && ((viewMode === 'list' && isAtBottomList) || (viewMode === 'card' && isAtBottomCard))" class="article-end-tip">
          <span>------已经到底啦------</span>
          <div class="copyright-info">
            <span class="pc-copyright">Copyright © 2024 OIer之路 All rights reserved. ｜ 闽ICP备2025095302号-1</span>
            <span class="mobile-copyright">Copyright © 2024 OIer之路 All rights reserved.<br>闽ICP备2025095302号-1</span>
          </div>
        </div>
      </div>

      <!-- 右侧过滤区域 -->
      <div class="filter-panel">
        <!-- 博主信息卡片 -->
        <el-card class="blogger-card" :style="contentCardStyle">
          <div class="blogger-info">
            <div class="blogger-avatar">
              <img src="@/assets/images/blog/head.png" alt="博主头像" />
            </div>
            <div class="blogger-details">
              <h3 class="blogger-name">{{ bloggerInfo.name }}</h3>
              <p class="blogger-bio">{{ bloggerInfo.bio }}</p>
              
              <div class="blogger-divider"></div>
              
              <div class="blogger-stats">
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(bloggerInfo.articleCount) }}</div>
                  <div class="stats-label">Articles</div>
                </div>
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(allTags.length) }}</div>
                  <div class="stats-label">Tags</div>
                </div>
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(bloggerInfo.totalReads) }}</div>
                  <div class="stats-label">Reads</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 联系方式卡片 -->
        <el-card class="filter-card contact-card" :style="contentCardStyle">
          <div class="contact-icons">
            <el-tooltip content="邮箱" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </el-tooltip>
            <el-tooltip content="GitHub" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.115 2.504.337 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
                </svg>
              </a>
            </el-tooltip>
            <el-tooltip content="QQ" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                  <path d="M21.395 15.035a40 40 0 0 0-.803-2.264l-1.079-2.695c.001-.032.014-.562.014-.836C19.526 4.632 17.351 0 12 0S4.474 4.632 4.474 9.241c0 .274.013.804.014.836l-1.08 2.695a39 39 0 0 0-.802 2.264c-1.021 3.283-.69 4.643-.438 4.673.54.065 2.103-2.472 2.103-2.472c0 1.469.756 3.387 2.394 4.771-.612.188-1.363.479-1.845.835-.434.32-.379.646-.301.778.343.578 5.883.369 7.482.189 1.6.18 7.14.389 7.483-.189.078-.132.132-.458-.301-.778-.483-.356-1.233-.646-1.846-.836 1.637-1.384 2.393-3.302 2.393-4.771 0 0 1.563 2.537 2.103 2.472.251-.03.581-1.39-.438-4.673"/>
                </svg>
              </a>
            </el-tooltip>
            <el-tooltip content="微信" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                  <path d="M2.224 21.667s4.24-1.825 4.788-2.056C15.029 23.141 22 17.714 22 11.898 22 6.984 17.523 3 12 3S2 6.984 2 11.898c0 1.86.64 3.585 1.737 5.013-.274.833-1.513 4.756-1.513 4.756zm5.943-9.707c.69 0 1.25-.569 1.25-1.271a1.26 1.26 0 0 0-1.25-1.271c-.69 0-1.25.569-1.25 1.27 0 .703.56 1.272 1.25 1.272zm7.583 0c.69 0 1.25-.569 1.25-1.271a1.26 1.26 0 0 0-1.25-1.271c-.69 0-1.25.569-1.25 1.27 0 .703.56 1.272 1.25 1.272z"/>
                </svg>
              </a>
            </el-tooltip>
            <el-tooltip content="B站" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                  <path d="M19.5 3.5h-2.38l.94-.94a1.49 1.49 0 0 0 0-2.12a1.51 1.51 0 0 0-2.12 0L12.88 3.5h-1.76L8.06.44a1.51 1.51 0 0 0-2.12 0a1.49 1.49 0 0 0 0 2.12l.94.94H4.5A4.51 4.51 0 0 0 0 8v10a4.51 4.51 0 0 0 4.5 4.5H5a1.75 1.75 0 0 0 3.46 0h7a1.75 1.75 0 0 0 3.46 0h.52A4.51 4.51 0 0 0 24 18V8a4.51 4.51 0 0 0-4.5-4.5zm1.5 14.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18V8a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5z"/>
                  <path d="M15 15.1a.73.73 0 0 0-.87.57a.54.54 0 0 1-.34.08c-.65 0-1-1-1-1a.76.76 0 0 0-.71-.49a.76.76 0 0 0-.7.49s-.4 1-1.05 1c-.23 0-.32-.06-.32 0a.75.75 0 0 0-1.55.25a1.69 1.69 0 0 0 1.79 1.24a2.35 2.35 0 0 0 1.75-.82a2.35 2.35 0 0 0 1.75.83A1.69 1.69 0 0 0 15.54 16a.77.77 0 0 0-.54-.9zm-5.24-4.45a.74.74 0 0 0-.88-.58l-3.94.8a.75.75 0 0 0-.59.89a.77.77 0 0 0 .74.6h.15l3.94-.8a.76.76 0 0 0 .58-.91zm9.3.22l-3.94-.8a.74.74 0 0 0-.88.58a.76.76 0 0 0 .58.89l3.94.8h.15a.77.77 0 0 0 .74-.6a.75.75 0 0 0-.59-.87"/>
                </svg>
              </a>
            </el-tooltip>
            <el-tooltip content="知乎" placement="top" :open-delay="300">
              <a class="contact-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" style="fill: currentColor">
                  <path d="M5.721 0C2.251 0 0 2.25 0 5.719V18.28C0 21.751 2.252 24 5.721 24h12.56C21.751 24 24 21.75 24 18.281V5.72C24 2.249 21.75 0 18.281 0zm1.964 4.078q-.408 1.096-.68 2.11h4.587c.545-.006.445 1.168.445 1.171H9.384a58 58 0 0 1-.112 3.797h2.712c.388.023.393 1.251.393 1.266H9.183a9.2 9.2 0 0 1-.408 2.102l.757-.604c.452.456 1.512 1.712 1.906 2.177.473.681.063 2.081.063 2.081l-2.794-3.382c-.653 2.518-1.845 3.607-1.845 3.607-.523.468-1.58.82-2.64.516 2.218-1.73 3.44-3.917 3.667-6.497H4.491c0-.015.197-1.243.806-1.266h2.71c.024-.32.086-3.254.086-3.797H6.598c-.136.406-.158.447-.268.753-.594 1.095-1.603 1.122-1.907 1.155.906-1.821 1.416-3.6 1.591-4.064.425-1.124 1.671-1.125 1.671-1.125M13.078 6h6.377v11.33h-2.573l-2.184 1.373.401-1.373h-1.219zm1.313 1.219v8.86h.623l.263.937 1.455-.938h1.456v-8.86z"/>
                </svg>
              </a>
            </el-tooltip>
          </div>
        </el-card>

        <el-card class="filter-card" :style="contentCardStyle">
          <div class="filter-content">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索文章标题或内容"
              prefix-icon="el-icon-search"
              @keyup.enter.native="handleSearch"
              clearable
            ></el-input>
          </div>
        </el-card>
        
        <!-- 移除文章分类卡片，因为已经移到顶部导航 -->
        
        <el-card class="filter-card" :style="contentCardStyle">
          <div class="filter-content">
            <el-input
              v-model="tagSearchKeyword"
              placeholder="搜索标签"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="tag-search-input"
              @input="filterTags"
            ></el-input>
            <div class="filter-tags">
              <el-tag 
                class="filter-tag-item"
                :class="{ active: selectedTag === '' }"
                @click="handleFilterTag('')"
                size="mini"
              >
                全部
              </el-tag>
              <el-tag 
                v-for="tag in filteredTags" 
                :key="tag"
                :effect="selectedTag === tag ? 'dark' : 'plain'"
                class="filter-tag-item"
                @click="handleFilterTag(tag)"
                size="mini"
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    
    <!-- 移动端按钮组，固定在右下角垂直排列 -->
    <div v-if="isMobile" class="mobile-action-buttons">
      <!-- 菜单按钮 -->
      <div class="mobile-btn-wrapper">
        <el-button
          class="mobile-icon-btn"
          @click="toggleMobileNav"
        >
          <i class="el-icon-menu"></i>
        </el-button>
      </div>

      <!-- 背景设置按钮 -->
      <div class="mobile-btn-wrapper">
        <background-settings @background-updated="handleBgSettingsUpdated" />
      </div>
    </div>
  </div>
</template>

<script>
import { getBlogArticles } from '@/api/article'
import BackgroundSettings from '@/components/BackgroundSettings.vue'
import request from '@/utils/request'

export default {
  name: 'BlogHome',
  components: {
    BackgroundSettings
  },
  data() {
    return {
      loading: false,
      articles: [],
      page: 1,
      pageSize: 12,
      total: 0,
      hasMore: true,
      searchKeyword: '',
      selectedType: '',
      selectedTag: '',
      allTags: [],
      filteredTags: [],
      tagSearchKeyword: '',
      bloggerInfo: {
        name: 'ziyanlin2013',
        bio: '一只小蒟蒻',
        articleCount: 0,
        totalReads: 0,
      },

      // 背景相关设置
      contentCardStyle: { backgroundColor: 'rgba(255, 255, 255, 0.8)' },
      backgroundLayerStyle: {},
      backgroundStyle: { backgroundColor: '#f0f2f5' },

      // 文章类型选项
      articleTypes: [
        { value: 'OI', label: 'OI' },
        { value: '题解', label: '题解' },
        { value: '游记', label: '游记' },
        { value: '生活', label: '生活' },
        { value: '学习', label: '学习' },
        { value: '科技', label: '科技' },
        { value: '情感', label: '情感' },
        { value: '游戏', label: '游戏' },
        { value: '随笔', label: '随笔' },
        { value: '其他', label: '其他' }
      ],

      // 移动端导航相关
      isMobile: false,
      mobileNavActive: false,
      viewMode: 'list',
      hasScrolled: false,
      isAtBottomCard: false,
      isAtBottomList: false,
      listObserver: null,
    }
  },
  created() {
    // 从 LocalStorage 读取视图模式，PC端保持设置，移动端强制列表模式
    const savedViewMode = localStorage.getItem('blogViewMode')
    this.checkDeviceType()
    if (this.isMobile) {
      this.viewMode = 'list'
    } else if (savedViewMode === 'list' || savedViewMode === 'card') {
      this.viewMode = savedViewMode
    }
    // 获取文章列表
    this.getArticles()
    // 获取所有标签
    this.getAllTags()
    // 获取博客统计信息
    this.getBlogStats()
    // 检测设备类型
    this.checkDeviceType()
  },
  mounted() {
    this.hideGlobalMobileMenu()
    this.$nextTick(() => {
      const articleContainer = document.querySelector('.article-cards')
      const filterPanel = document.querySelector('.filter-panel')
      const filterTags = document.querySelector('.filter-tags')

      if (articleContainer) {
        articleContainer.addEventListener('scroll', this.handleScroll)
        this.checkInitialLoad()
        articleContainer.addEventListener('wheel', function(event) {
          const scrollTop = articleContainer.scrollTop
          const scrollHeight = articleContainer.scrollHeight
          const clientHeight = articleContainer.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            return false
          }
        }, { passive: false })
      }

      // 如果初始是列表视图，添加列表滚动监听
      document.body.style.overflow = 'hidden'
      document.addEventListener('wheel', this.preventScrollOutsideContent, { passive: false })

      if (filterPanel) {
        filterPanel.addEventListener('wheel', function(event) {
          const scrollTop = filterPanel.scrollTop
          const scrollHeight = filterPanel.scrollHeight
          const clientHeight = filterPanel.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            return false
          }
        }, { passive: false })
      }

      if (filterTags) {
        filterTags.addEventListener('wheel', function(event) {
          event.stopPropagation()

          const scrollTop = filterTags.scrollTop
          const scrollHeight = filterTags.scrollHeight
          const clientHeight = filterTags.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
          } else {
            event.preventDefault()
            filterTags.scrollTop += event.deltaY * 0.5
          }
        }, { passive: false })

        filterTags.style.webkitOverflowScrolling = 'touch'
        filterTags.style.touchAction = 'pan-y'
      }

      window.addEventListener('resize', this.handleResize)
      this.checkDeviceType()

      // 列表模式用 IntersectionObserver 检测滚动到底
      this.setupListObserver()
    })
  },
  beforeDestroy() {
    const articleContainer = document.querySelector('.article-cards')
    const filterPanel = document.querySelector('.filter-panel')
    const filterTags = document.querySelector('.filter-tags')

    if (articleContainer) {
      articleContainer.removeEventListener('scroll', this.handleScroll)
      articleContainer.removeEventListener('wheel', function() {})
    }

    if (this.listObserver) {
      this.listObserver.disconnect()
      this.listObserver = null
    }

    document.removeEventListener('wheel', this.preventScrollOutsideContent)

    if (filterPanel) {
      filterPanel.removeEventListener('wheel', function() {})
    }

    if (filterTags) {
      filterTags.removeEventListener('wheel', function() {})
    }

    window.removeEventListener('resize', this.handleResize)
    document.body.style.overflow = ''
    this.restoreGlobalMobileMenu()
  },
  methods: {
    restoreGlobalMobileMenu() {
      const globalMobileMenuBtn = document.querySelector('#app > .mobile-menu-btn')
      if (globalMobileMenuBtn) {
        if (window.innerWidth <= 768) {
          globalMobileMenuBtn.style.display = 'flex'
        }
      }
    },

    hideGlobalMobileMenu() {
      const globalMobileMenuBtn = document.querySelector('#app > .mobile-menu-btn')
      if (globalMobileMenuBtn) {
        globalMobileMenuBtn.style.display = 'none'
      }
    },

    handleBgSettingsUpdated(settings) {
      this.contentCardStyle = settings.contentCardStyle
      this.backgroundLayerStyle = settings.backgroundLayerStyle
      this.backgroundStyle = settings.backgroundStyle
    },

    getArticleTypeStyle(type) {
      const styleMap = {
        'OI': '#2473EB',
        '题解': '#4a9a2e',
        '游记': '#CC7000',
        '生活': '#D73A3A',
        '学习': '#6B2E9B',
        '科技': '#0E8068',
        '情感': '#B83A00',
        '游戏': '#1E6AA3',
        '随笔': '#1E8A4A',
        '其他': '#A02B1E'
      }
      return styleMap[type] || ''
    },

    // 获取浅底色样式
    getArticleTypeLightStyle(type) {
      const gradientStyleMap = {
        'OI': '#D6E8FF',
        '题解': '#D8F5D0',
        '游记': '#FFE8CC',
        '生活': '#FFD6D6',
        '学习': '#E0D0F0',
        '科技': '#D0EDE8',
        '情感': '#FFD8CC',
        '游戏': '#D0E8FF',
        '随笔': '#D0F0E0',
        '其他': '#FFD0D0'
      }
      return gradientStyleMap[type] || '#F0F0F0'
    },

    getArticleTypeClass(type) {
      const classMap = {
        'OI': 'blue',
        '题解': 'green',
        '游记': 'orange',
        '生活': 'red',
        '学习': 'purple',
        '科技': 'teal',
        '情感': 'brown',
        '游戏': 'navy',
        '随笔': 'emerald',
        '其他': 'crimson'
      }
      return classMap[type] || 'default'
    },

    getArticleSummary(content) {
      if (!content) return '暂无内容'

      const plainText = content
        .replace(/!\[.*?\]\(.*?\)/g, '')
        .replace(/\[.*?\]\(.*?\)/g, '$1')
        .replace(/#{1,6}\s+/g, '')
        .replace(/(\*\*|__)(.*?)(\*\*|__)/g, '$2')
        .replace(/(\*|_)(.*?)(\*|_)/g, '$2')
        .replace(/`{1,3}[\s\S]*?`{1,3}/g, '')
        .replace(/~~(.*?)~~/g, '$1')
        .replace(/\$\$([\s\S]*?)\$\$/g, '')
        .replace(/\$(.*?)\$/g, '')
        .replace(/\n+/g, ' ')
        .trim()

      const maxLength = 100

      if (plainText.length <= maxLength) {
        return plainText
      }

      const breakPoints = ['. ', '。', '! ', '！', '? ', '？', '; ', '；', '，', ', ']
      let bestBreakPoint = maxLength

      for (const point of breakPoints) {
        const index = plainText.lastIndexOf(point, maxLength - 1)
        if (index > maxLength * 0.6) {
          bestBreakPoint = index + point.length
          break
        }
      }

      if (bestBreakPoint === maxLength) {
        const lastSpace = plainText.lastIndexOf(' ', maxLength - 1)
        if (lastSpace > maxLength * 0.8) {
          bestBreakPoint = lastSpace
        }
      }

      return plainText.substring(0, bestBreakPoint) + (bestBreakPoint < plainText.length ? '...' : '')
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },

    formatReadCount(count) {
      if (!count) return 0
      return count > 999 ? '999+' : count
    },

    async getArticles(isLoadMore = false) {
      if (this.loading) return

      this.loading = true
      try {
        const params = {
          page: this.page,
          size: this.pageSize,
          keyword: this.searchKeyword,
          article_type: this.selectedType,
          article_tag: this.selectedTag,
          exact_tag_match: this.selectedTag ? true : false,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (isLoadMore) {
          this.articles = [...this.articles, ...response.data.items]
        } else {
          this.articles = response.data.items
        }

        this.total = response.data.total
        this.hasMore = this.articles.length < this.total

        this.extractAllTags()

        if (isLoadMore) {
          this.$nextTick(() => {
            this.checkInitialLoad()
            this.setupListObserver()
          })
        }
      } catch (error) {
        console.error('获取文章列表失败：', error)
        this.$message.error('获取文章列表失败')
      }
      this.loading = false
      if (!isLoadMore) {
        this.checkInitialLoad()
        this.setupListObserver()
      }
    },

    loadMore() {
      if (!this.hasMore || this.loading) return
      this.page++
      this.getArticles(true)
    },

    handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true
      }

      const articleContainer = document.querySelector('.article-cards')
      if (!articleContainer) return

      const scrollHeight = articleContainer.scrollHeight
      const scrollTop = articleContainer.scrollTop
      const clientHeight = articleContainer.clientHeight
      const isAtBottom = scrollHeight - scrollTop - clientHeight < 100

      // 实时判断是否在底部（卡片和列表共用同一个滚动容器）
      this.isAtBottomCard = isAtBottom
      this.isAtBottomList = isAtBottom

      if (this.loading || !this.hasMore) return

      if (isAtBottom) {
        this.loadMore()
      }
    },

    handleViewArticle(article) {
      this.$router.push(`/blog/view/${article.article_code}`)
    },

    handleSearch() {
      this.page = 1
      this.hasScrolled = false
      this.isAtBottomCard = false
      this.isAtBottomList = false
      this.getArticles()
      this.closeMobileNav()
    },

    handleFilterType(type) {
      this.selectedType = type
      this.page = 1
      this.hasScrolled = false
      this.isAtBottomCard = false
      this.isAtBottomList = false
      this.getArticles()
    },

    handleFilterTag(tag) {
      this.selectedTag = tag
      this.page = 1
      this.hasScrolled = false
      this.isAtBottomCard = false
      this.isAtBottomList = false
      this.getArticles()
    },

    extractAllTags() {
      const tagsSet = new Set()
      this.articles.forEach(article => {
        if (article.article_tag) {
          const tags = article.article_tag.split(',')
          tags.forEach(tag => tagsSet.add(tag.trim()))
        }
      })
    },

    async getAllTags() {
      try {
        const params = {
          page: 1,
          size: 1000,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (response.data && response.data.items) {
          const tagsSet = new Set()

          response.data.items.forEach(article => {
            if (article.article_tag) {
              const tags = article.article_tag.split(',')
              tags.forEach(tag => tagsSet.add(tag.trim()))
            }
          })

          this.allTags = Array.from(tagsSet).sort()
          this.filteredTags = [...this.allTags]
        }
      } catch (error) {
        console.error('获取所有标签失败：', error)
      }
    },

    filterTags() {
      if (!this.tagSearchKeyword) {
        this.filteredTags = [...this.allTags]
        return
      }

      const keyword = this.tagSearchKeyword.toLowerCase()
      this.filteredTags = this.allTags.filter(tag =>
        tag.toLowerCase().includes(keyword)
      )
    },

    async getBlogStats() {
      try {
        const params = {
          page: 1,
          size: 1,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)
        if (response.data && response.data.total !== undefined) {
          this.bloggerInfo.articleCount = response.data.total
        }

        await this.calculateTotalReads()

      } catch (error) {
        console.error('获取博客统计信息失败：', error)
      }
    },

    async calculateTotalReads() {
      try {
        const params = {
          page: 1,
          size: 1000,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (response.data && response.data.items) {
          let totalReads = 0
          response.data.items.forEach(article => {
            totalReads += article.read_count || 0
          })

          this.bloggerInfo.totalReads = totalReads
        }
      } catch (error) {
        console.error('计算总阅读量失败：', error)
        this.bloggerInfo.totalReads = 0
      }
    },

    checkInitialLoad() {
      this.$nextTick(() => {
        const articleContainer = document.querySelector('.article-cards')
        if (!articleContainer) return

        const scrollHeight = articleContainer.scrollHeight
        const clientHeight = articleContainer.clientHeight

        if (scrollHeight <= clientHeight && this.hasMore && !this.loading) {
          this.loadMore()
        }
      })
    },

    preventScrollOutsideContent(event) {
      const articleCards = document.querySelector('.article-cards')
      const filterPanel = document.querySelector('.filter-panel')
      const filterTags = document.querySelector('.filter-tags')

      if (articleCards && filterPanel) {
        const isInArticleCards = articleCards.contains(event.target) || articleCards === event.target
        const isInFilterPanel = filterPanel.contains(event.target) || filterPanel === event.target
        const isInFilterTags = filterTags && (filterTags.contains(event.target) || filterTags === event.target)

        if (isInFilterTags) {
          return true
        }

        if (!isInArticleCards && !isInFilterPanel) {
          event.preventDefault()
          event.stopPropagation()
          return false
        }

        if (isInFilterPanel) {
          const scrollTop = filterPanel.scrollTop
          const scrollHeight = filterPanel.scrollHeight
          const clientHeight = filterPanel.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            event.stopPropagation()
            return false
          }
        }

        if (isInArticleCards) {
          const scrollTop = articleCards.scrollTop
          const scrollHeight = articleCards.scrollHeight
          const clientHeight = articleCards.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            event.stopPropagation()
            return false
          }
        }
      }
    },

    formatStatNumber(num) {
      if (num === undefined || num === null) return '0'
      if (num < 1000) return num.toString()
      if (num < 1000000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      }
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
    },

    toggleMobileNav() {
      this.mobileNavActive = !this.mobileNavActive
    },

    toggleViewMode() {
      // 移动端不允许切换到卡片模式
      if (this.isMobile) return

      const oldView = this.viewMode
      this.viewMode = this.viewMode === 'card' ? 'list' : 'card'
      localStorage.setItem('blogViewMode', this.viewMode)

      // 切换视图时重置滚动状态
      this.$nextTick(() => {
        if (this.viewMode === 'list') {
          // 切换到列表视图，重新设置 observer
          this.setupListObserver()
        } else if (oldView === 'list') {
          // 重置列表滚动状态
          this.isAtBottomList = false
          if (this.listObserver) {
            this.listObserver.disconnect()
            this.listObserver = null
          }
        }
        // 重置卡片滚动状态
        this.isAtBottomCard = false
      })
    },

    setupListObserver() {
      // 清理旧的 observer
      if (this.listObserver) {
        this.listObserver.disconnect()
        this.listObserver = null
      }

      // 等待列表渲染完成后观察最后一个列表项
      this.$nextTick(() => {
        const listItems = document.querySelectorAll('.article-list-item')
        if (listItems.length === 0) return

        const lastItem = listItems[listItems.length - 1]
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isAtBottomList = entry.isIntersecting
          })
        }, {
          root: document.querySelector('.article-cards'),
          threshold: 0
        })
        observer.observe(lastItem)
        this.listObserver = observer
      })
    },

    isEnglishType(type) {
      return /^[A-Za-z]+$/.test(type)
    },

    closeMobileNav() {
      this.mobileNavActive = false
    },

    showSearchDialog() {
      this.closeMobileNav()
      this.$nextTick(() => {
        const searchInput = document.querySelector('.mobile-nav-search .el-input__inner')
        if (searchInput) {
          this.mobileNavActive = true
          setTimeout(() => {
            searchInput.focus()
          }, 300)
        }
      })
    },

    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768
    },

    handleResize() {
      const wasMobile = this.isMobile
      this.checkDeviceType()
      if (!this.isMobile) {
        this.mobileNavActive = false
      }
      // 切换到移动端时强制使用列表模式
      if (!wasMobile && this.isMobile) {
        this.viewMode = 'list'
        localStorage.setItem('blogViewMode', 'list')
      }
      this.hideGlobalMobileMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.blog-home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden; /* 防止整体出现滚动条 */
  padding-bottom: 20px;
  
  // 添加这个类来覆盖App.vue中的全局移动端样式
  :deep(.mobile-menu-btn) {
    display: none !important; // 强制隐藏App.vue中的移动端菜单按钮
  }
  
  .background-layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    pointer-events: none;
    z-index: 0;
  }
  
  /* 移动端按钮组的样式 */
  .mobile-action-buttons {
    position: fixed !important; /* 确保固定定位 */
    right: 15px !important;
    bottom: 80px !important;
    display: flex !important; /* 确保显示 */
    flex-direction: column !important;
    gap: 15px !important;
    z-index: 2001 !important; /* 增加z-index确保显示在最上层 */
    
    .mobile-icon-btn {
      width: 40px !important;
      height: 40px !important;
      border-radius: 40px !important;
      background-color: rgba(255, 255, 255, 0.5) !important;
      color: #409eff !important;
      border: none !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      padding: 0 !important;
      transition: all 0.3s ease !important;
      
      i {
        font-size: 20px !important;
      }
      
      &:hover, &:focus {
        background-color: rgba(255, 255, 255, 0.8) !important;
        transform: scale(1.05) !important;
      }
      
      &:active {
        background-color: rgba(255, 255, 255, 0.9) !important;
        transform: scale(0.95) !important;
      }
    }
  }
  
  /* 统一移动端按钮包装器样式 */
  .mobile-btn-wrapper {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 40px !important;
    height: 40px !important;
  }

  /* 确保移动端背景设置按钮包装器正确显示 */
  .mobile-bg-settings-wrapper {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 40px !important;
    height: 40px !important;
    z-index: 2001 !important;
  }
  
  .blog-header {
    height: 118px; /* 从126px减少到118px，补偿副标题与横线之间间距的减少 */
    padding: 0 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    position: fixed; /* 改为固定定位 */
    top: 0; /* 固定在顶部 */
    left: 0; /* 固定在左侧 */
    right: 0; /* 固定在右侧 */
    z-index: 10; /* 提高z-index确保在其他元素上方 */
    width: 100%; /* 确保宽度为100% */
    
    .blog-header-content {
      max-width: 1200px;
      margin: 0 auto;
      height: 80px; /* 保持减少后的高度 */
      margin-bottom: 0; /* 确保没有底部边距 */
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .blog-info {
        padding-bottom: 0;
        
        .blog-title {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          color: #303133;
          position: relative;
          
          .crown-icon {
            position: absolute;
            left: -27px;
            top: -16px;
            font-size: 32px;
            transform: rotate(-45deg);
            display: inline-block;
            z-index: 2;
          }
        }
        
        .blog-subtitle {
          font-size: 14px;
          color: #606266;
          margin-top: 5px;
        }
      }

      /* 右侧按钮组容器 */
      .header-right-buttons {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-left: auto; /* 确保靠右对齐 */
        margin-right: 20px; /* 添加右侧边距 */

        .bg-settings-container {
          display: flex;
          align-items: center;
        }

        .view-toggle-btn {
          background-color: #409eff;
          color: #ffffff;
          border-color: #409eff;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
          transform: translateY(0);
          transition: all 0.3s ease;

          i {
            font-size: 20px;
            margin: 0;
            line-height: 1;
          }

          &:hover {
            background-color: #66b1ff;
            color: #ffffff;
            border-color: #66b1ff;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
            transform: translateY(-2px);
          }

          &:active {
            background-color: #3a8ee6;
            color: #ffffff;
            border-color: #3a8ee6;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
            transform: translateY(1px);
          }
        }
      }
    }

    .blog-nav {
      max-width: 1200px;
      margin: 0 auto;
      height: 32px; /* 恢复原始高度 */
      display: flex;
      justify-content: flex-start; /* 设置为左对齐 */
      align-items: center; /* 恢复垂直居中 */
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      padding-top: 0; /* 恢复原始内边距 */
      margin-top: -2px; /* 保持横线与副标题之间的减少间距 */
      position: relative; /* 添加相对定位 */
      
      /* 移除这个伪元素，它可能干扰定位 */
      &::after {
        display: none;
      }
      
      .nav-buttons {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start; /* 设置为左对齐 */
        width: auto; /* 改为auto，让按钮组根据内容自适应宽度 */
        
        .nav-button {
          min-width: 70px;
          text-align: center;
          margin-right: 0px; /* 设置为0，因为按钮已经有padding */
          margin-left: 0px !important; /* 覆盖Element UI的默认margin-left: 10px */
          border-radius: 4px;
          transition: all 0.3s;
          font-weight: 500;
          padding: 8px 0px;
          position: relative; /* 添加相对定位以支持三角形定位 */
          margin-bottom: 0; /* 确保按钮底部没有额外的margin */
          
          &.el-button--primary {
            background-color: #409EFF;
            color: white;
            border-color: #409EFF;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
            
            &:hover {
              background-color: #66b1ff;
              border-color: #66b1ff;
              box-shadow: 0 2px 10px rgba(64, 158, 255, 0.3);
            }
          }
          
          &.el-button--text {
            color: #606266;
            
            &:hover {
              color: #409EFF;
              background-color: rgba(64, 158, 255, 0.1);
            }
          }
          
          &:last-child {
            margin-right: 0;
          }
          
          /* 添加选中按钮的三角形指示器，类似tooltips风格 */
          &.selected-nav-button {
            color: white !important; /* 强制文字为白色 */
            margin-bottom: 0;
            position: relative;
            
            &::after {
              content: '';
              position: absolute;
              bottom: -9px; /* 恢复原始位置 */
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-top: 8px solid var(--btn-bg-color, #409EFF); /* 使用CSS变量设置颜色 */
              z-index: 2; /* 确保三角形在最上层 */
            }
          }
          
          /* 移除不再需要的样式 */
          &.el-button--primary:not(.selected-nav-button)::after {
            display: none;
          }
        }
        
        .bg-settings-container {
          margin-left: 2px; /* 从5px减少到2px，保持少量间距 */
          display: flex;
          align-items: center;
        }
      }
    }
  }
  
  .blog-content {
    width: 1200px; // 明确宽度，确保 calc() 有正确的基准
    max-width: 1200px;
    margin: 125px auto 0; /* 顶部margin改为头部高度，确保内容不被头部遮挡 */
    display: flex;
    gap: 20px;
    position: relative;
    z-index: 1;
    height: calc(100vh - 125px); /* 恢复原来的高度计算，使内容区域延伸到页面底部 */
    overflow: hidden; /* 防止整体出现滚动条 */
    padding-bottom: 0; /* 移除底部内边距 */
    
    .article-cards {
      flex: 1; // 控制 column 方向的高度，填满父容器
      width: calc(100% - 270px) !important; // 控制 row 方向的宽度
      min-width: 0;
      display: flex;
      flex-direction: column;
      overflow-y: auto; /* 允许文章区域滚动 */
      padding-right: 0; /* 移除为滚动条预留的空间 */
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      overscroll-behavior: none !important; /* 禁止过度滚动 - 添加!important增强优先级 */
      -webkit-overscroll-behavior: none !important; /* Safari支持 */
      -ms-scroll-chaining: none !important; /* IE/Edge支持 */
      -webkit-overflow-scrolling: touch; /* 在iOS上使用原生滚动动量 */
      
      /* 隐藏滚动条但保持滚动功能 - Webkit浏览器 */
      &::-webkit-scrollbar {
        display: none;
      }
      
      // 修改暂无文章区域的样式
      .no-data-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
      }

      // 修改暂无数据区域的样式
      .no-data {
        min-height: 400px;
        border-radius: 8px; // 与文章卡片一致的圆角
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #909399;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); // 与文章卡片一致的阴影
        width: 100%;
        overflow: hidden;
        transition: transform 0.3s, box-shadow 0.3s;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        
        .no-data-content {
          text-align: center;
          width: 100%;
          padding: 40px 20px;
          box-sizing: border-box;
          
          i {
            font-size: 80px;
            margin-bottom: 20px;
            color: #dcdfe6;
          }
          
          .no-data-title {
            font-size: 20px;
            color: #606266;
            font-weight: 500;
            display: block;
          margin-bottom: 10px;
          }
        }
        
        .no-data-tips {
          margin-top: 10px;
          font-size: 14px;
          color: #909399;
          line-height: 1.5;
        }
      }
      
      .article-card-container {
        width: 100%;

        .waterfall {
          display: grid;
          grid-template-columns: repeat(3, minmax(280px, 1fr));
          grid-gap: 20px;

          @media screen and (max-width: 1200px) {
            grid-template-columns: repeat(2, 1fr);
          }

          @media screen and (max-width: 768px) {
            grid-template-columns: 1fr;
          }

          .article-card {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            cursor: pointer;
            position: relative;
            display: flex;
            flex-direction: column;
            height: 200px;
            border: 1px solid rgba(0, 0, 0, 0.03);
            /* 移除固定透明背景 */

            .article-type-decoration {
              position: absolute;
              top: -60px;
              right: -60px;
              width: 120px;
              height: 120px;
              background: rgba(0, 0, 0, 0.03);
              transform: rotate(45deg);
              z-index: 1;
              transition: all 0.3s ease;
            }

            &.article-card-blue .article-type-decoration {
              background: rgba(64, 158, 255, 0.08);
            }

            &.article-card-green .article-type-decoration {
              background: rgba(103, 194, 58, 0.08);
            }

            &.article-card-orange .article-type-decoration {
              background: rgba(230, 162, 60, 0.08);
            }

            &.article-card-red .article-type-decoration {
              background: rgba(245, 108, 108, 0.08);
            }

            &.article-card-purple .article-type-decoration {
              background: rgba(142, 68, 173, 0.08);
            }

            &.article-card-teal .article-type-decoration {
              background: rgba(22, 160, 133, 0.08);
            }

            &.article-card-brown .article-type-decoration {
              background: rgba(211, 84, 0, 0.08);
            }

            &.article-card-navy .article-type-decoration {
              background: rgba(41, 128, 185, 0.08);
            }

            &.article-card-emerald .article-type-decoration {
              background: rgba(39, 174, 96, 0.08);
            }

            &.article-card-crimson .article-type-decoration {
              background: rgba(192, 57, 43, 0.08);
            }

            &:hover .article-type-decoration {
              transform: rotate(45deg) scale(1.2);
            }

            .read-count-bubble {
              position: absolute;
              top: 12px;
              right: 8px;
              background: rgba(64, 158, 255, 0.5);
              color: white;
              padding: 5px 12px;
              border-radius: 20px;
              font-size: 12px;
              display: flex;
              align-items: center;
              gap: 4px;
              z-index: 5;
              transition: all 0.3s ease;
              backdrop-filter: blur(2px);
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

              i {
                font-size: 14px;
              }
            }

            /* 置顶+加密标签容器 */
            .top-badges {
              position: absolute;
              top: 15px;
              left: 8px;
              display: flex;
              align-items: center;
              gap: 6px;
              z-index: 5;
              pointer-events: none;
            }

            /* 置顶胶囊样式 */
            .top-pill {
              height: 25px;
              width: 25px;
              padding: 0;
              border-radius: 4px;
              background: #E8F3FF;
              color: #1f6feb;
              font-size: 14px;
              font-weight: 700;
              letter-spacing: 0.3px;
              box-shadow: 0 2px 6px rgba(64, 158, 255, 0.18);
              border: 1px solid rgba(64, 158, 255, 0.28);
              display: inline-flex;
              align-items: center;
              justify-content: center;

              i { font-size: 14px; font-weight: bold; }
            }

            /* 加密胶囊样式 */
            .encrypted-pill {
              height: 25px;
              width: 25px;
              padding: 0;
              border-radius: 4px;
              background: rgba(230, 162, 60, 0.15);
              color: #E6A23C;
              font-size: 12px;
              font-weight: 600;
              letter-spacing: 0.3px;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
              border: 1px solid rgba(230, 162, 60, 0.2);
              display: inline-flex;
              align-items: center;
              justify-content: center;

              i { font-size: 14px; font-weight: bold; }
            }

            &:hover {
              transform: translateY(-6px);
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

              .article-title {
                color: #409EFF;
              }

              .read-count-bubble {
                background: rgba(64, 158, 255, 0.8);
                transform: scale(1.05);
              }

              .read-more {
                color: #409EFF;

                i {
                  transform: translateX(4px);
                }
              }
            }

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 3px;
              background: linear-gradient(90deg, #409EFF, #67C23A, #E6A23C, #F56C6C);
              transform: scaleX(0);
              transform-origin: left;
              transition: transform 0.3s ease;
              z-index: 3;
            }

            &:hover::before {
              transform: scaleX(1);
            }

            .article-cover {
              height: 50px; // 装饰性色条高度
              flex-shrink: 0;
              overflow: hidden;
              position: relative;
              border-radius: 12px 12px 0 0;

              // 装饰色条各类型颜色
              &.article-cover-blue { background: linear-gradient(135deg, rgba(64,158,255,0.15), rgba(64,158,255,0.05)); }
              &.article-cover-green { background: linear-gradient(135deg, rgba(103,194,58,0.15), rgba(103,194,58,0.05)); }
              &.article-cover-orange { background: linear-gradient(135deg, rgba(230,162,60,0.15), rgba(230,162,60,0.05)); }
              &.article-cover-red { background: linear-gradient(135deg, rgba(245,108,108,0.15), rgba(245,108,108,0.05)); }
              &.article-cover-purple { background: linear-gradient(135deg, rgba(142,68,173,0.15), rgba(142,68,173,0.05)); }
              &.article-cover-teal { background: linear-gradient(135deg, rgba(22,160,133,0.15), rgba(22,160,133,0.05)); }
              &.article-cover-brown { background: linear-gradient(135deg, rgba(211,84,0,0.15), rgba(211,84,0,0.05)); }
              &.article-cover-navy { background: linear-gradient(135deg, rgba(41,128,185,0.15), rgba(41,128,185,0.05)); }
              &.article-cover-emerald { background: linear-gradient(135deg, rgba(39,174,96,0.15), rgba(39,174,96,0.05)); }
              &.article-cover-crimson { background: linear-gradient(135deg, rgba(192,57,43,0.15), rgba(192,57,43,0.05)); }
              &.article-cover-default { background: linear-gradient(135deg, rgba(0,0,0,0.04), rgba(0,0,0,0.02)); }
            }

            .article-info {
              padding: 0 15px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              flex: 1;
              position: relative;
              background: transparent;
              border-top: 1px solid rgba(0, 0, 0, 0.03);
              backdrop-filter: blur(5px);

              .article-content {
                flex: none;
                padding: 10px 0 0;

                .title-wrap {
                  height: 60px;
                  overflow: hidden;
                }

                .article-title {
                  font-size: 16px;
                  font-weight: 600;
                  color: #303133;
                  line-height: 30px;
                  margin: 0 0 10px 0;
                  word-break: break-word;
                  overflow-wrap: break-word;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  transition: color 0.3s ease;
                }

                .article-meta {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 10px;
                  padding-left: 0;

                  .article-type {
                    border: none;
                    font-weight: 500;
                    letter-spacing: 0.5px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    padding: 0 8px;
                    margin-left: 2px;
                  }

                  .article-stats {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 12px;
                    color: #909399;

                    .article-views, .article-time {
                      display: flex;
                      align-items: center;

                      i {
                        margin-right: 4px;
                        font-size: 14px;
                      }
                    }

                    .stats-divider {
                      color: #DCDFE6;
                      font-size: 12px;
                      margin: 0 -5px;
                    }
                  }
                }
              }

              .article-divider {
                height: 1px;
                background: linear-gradient(to right, rgba(0,0,0,0.03), rgba(0,0,0,0.06), rgba(0,0,0,0.03));
                margin: 6px 0;
              }

              .article-footer {
                position: relative;
                padding: 0 0 4px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &::before {
                  display: none;
                }

                .article-tags {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 6px;
                  min-height: 24px;
                  flex: 1;

                  .article-tag {
                    margin: 0;
                    transition: all 0.2s ease;
                    border-radius: 12px;
                    padding: 0 8px;
                    font-size: 11px;
                    background: rgba(0,0,0,0.03);
                    color: #606266;
                    border: none;

                    &:hover {
                      transform: scale(1.05);
                      background: rgba(64, 158, 255, 0.1);
                      color: #409EFF;
                    }
                  }
                }

                .article-tags-placeholder {
                  min-height: 24px;
                  flex: 1;
                }

                .read-more {
                  font-size: 12px;
                  color: #909399;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  transition: color 0.3s ease;

                  i {
                    transition: transform 0.3s ease;
                  }
                }
              }
            }
          }
        }
      }

      /* 列表视图样式 */
      .article-list-container {
        min-width: 0;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow: visible; // 让内容自然溢出，由父容器.article-cards处理滚动
        scrollbar-width: none;
        -ms-overflow-style: none;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }

        .article-list-empty {
          width: 100%;
          min-height: 400px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #909399;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          box-sizing: border-box;

          .no-data-content {
            width: 100%;
            text-align: center;
            padding: 40px 20px;
            box-sizing: border-box;

            i {
              font-size: 80px;
              margin-bottom: 20px;
              color: #dcdfe6;
            }

            .no-data-title {
              font-size: 20px;
              color: #606266;
              font-weight: 500;
              display: block;
              margin-bottom: 10px;
            }

            .no-data-tips {
              margin-top: 10px;
              font-size: 14px;
              color: #909399;
              line-height: 1.5;
            }
          }
        }

        .article-list-item {
          display: flex;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          cursor: pointer;
          margin-bottom: 12px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);

            .list-item-title {
              color: #409EFF;
            }

            .list-item-arrow {
              transform: translateX(4px);
            }
          }

          .list-item-type {
            width: 60px;
            min-height: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            border-radius: 4px;
            position: relative;
            padding: 6px 0;
            box-sizing: border-box;
            box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.05);

            .type-text {
              font-size: 13px;
              font-weight: 800;
              writing-mode: vertical-rl;
              text-orientation: mixed;
              letter-spacing: 4px;

              &.is-english {
                writing-mode: horizontal-tb;
                letter-spacing: 0;
              }
            }

            .type-divider {
              width: 70%;
              height: 0;
              border-top: 1px dashed currentColor;
              opacity: 0.5;
              margin: 4px 0;
            }

            .type-views {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 2px;
              font-size: 10px;
              font-weight: 700;
              opacity: 1;

              &::before {
                content: '🔥';
              }
            }
          }

          .list-item-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 2px 15px;
            min-height: 60px;
            min-width: 0;
            box-sizing: border-box;
            overflow: hidden;
            width: 100%;

            .list-item-row1 {
              display: flex;
              align-items: center;
              height: 30px;
              min-width: 0;
              overflow: hidden;
              margin-bottom: 2px;

              .list-item-title {
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                margin: 0;
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                transition: color 0.3s ease;
                line-height: 30px;
              }

              .list-item-views {
                display: flex;
                align-items: center;
                gap: 2px;
                color: #909399;
                font-size: 12px;
                flex-shrink: 0;
                max-width: 50px;
                justify-content: flex-end;

                i {
                  font-size: 14px;
                }
              }
            }

            .list-item-divider {
              width: 70%;
              height: 1px;
              margin: 2px auto;
              background: linear-gradient(
                to right,
                transparent 0%,
                rgba(0, 0, 0, 0.1) 20%,
                rgba(0, 0, 0, 0.1) 80%,
                transparent 100%
              );
            }

            .list-item-row2 {
              margin-top: 2px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 22px;
              padding-bottom: 4px;

              .list-item-left {
                display: flex;
                align-items: center;
                gap: 8px;
                flex: 1;
                overflow: hidden;

.list-item-badge {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 18px;
                  height: 18px;
                  border-radius: 4px;
                  flex-shrink: 0;
                  font-size: 12px;
                  font-weight: 700;

                  i {
                    font-size: 10px;
                    font-weight: bold;
                  }

                  &.top-badge {
                    background: #E8F3FF;
                    color: #1f6feb;
                  }

                  &.lock-badge {
                    background: rgba(230, 162, 60, 0.15);
                    color: #E6A23C;
                  }
                }

                .list-item-tags {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 6px;
                  overflow: hidden;

                  .list-tag {
                    margin: 0;
                    padding: 0 8px;
                    height: 20px;
                    line-height: 18px;
                    font-size: 10px;
                    border-radius: 10px;
                    background: rgba(0, 0, 0, 0.03);
                    color: #606266;
                    border: none;
                  }
                }
              }

              .list-item-right {
                display: flex;
                align-items: center;
                flex-shrink: 0;
                margin-left: 10px;

                .list-item-date {
                  font-size: 11px;
                  color: #909399;
                }
              }
            }
          }
        }
      }

      .load-more, .loading-more, .article-end-tip {
        text-align: center;
        margin-top: 10px;
        padding: 5px 0;

        .el-button {
          font-size: 14px;
        }
      }
      
      .loading-more {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        color: #909399;
        
        i {
          font-size: 16px;
        }
      }
      
      .article-end-tip {
        text-align: center;

        span {
          color: #909399;
          font-size: 12px;
        }

        .copyright-info {
          text-align: center;
          margin: 5px auto;
          width: 100%;

          .pc-copyright {
            display: inline;
          }

          .mobile-copyright {
            display: none;
          }
        }
      }
    }

    .filter-panel {
      width: 250px;
      flex-shrink: 0;
      height: 100%; /* 确保高度占满容器 */
      overflow-y: auto; /* 允许过滤区域独立滚动 */
      padding-right: 0; /* 移除为滚动条预留的空间 */
      padding-bottom: 0; /* 移除底部内边距 */
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      overscroll-behavior: none !important; /* 禁止过度滚动 - 添加!important增强优先级 */
      -webkit-overscroll-behavior: none !important; /* Safari支持 */
      -ms-scroll-chaining: none !important; /* IE/Edge支持 */
      -webkit-overflow-scrolling: touch; /* 在iOS上使用原生滚动动量 */
      
      /* 隐藏滚动条但保持滚动功能 - Webkit浏览器 */
      &::-webkit-scrollbar {
        display: none;
      }
      
      .blogger-card, .filter-card {
        margin-bottom: 20px;
        border-radius: 8px !important; /* 强制覆盖 el-card 默认样式 */
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important; /* 强制覆盖 el-card 默认样式 */
        transition: transform 0.3s, box-shadow 0.3s;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important; /* 强制覆盖 el-card 默认样式 */
        }
        
        &:last-child {
          margin-bottom: 0;
        }
        
        /* 覆盖 el-card 的内部样式 */
        :deep(.el-card__body) {
          padding: 15px;
        }
      }
      
      .blogger-card {
        height: 280px; // 恢复原来的高度
        box-sizing: border-box;
        
        .blogger-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 20px 25px;
          height: 100%;
          box-sizing: border-box;
          justify-content: center;
          
          .blogger-avatar {
            width: 90px; /* 从80px增加到90px，使头像更加突出 */
            height: 90px; /* 从80px增加到90px，使头像更加突出 */
            border-radius: 50%;
            overflow: hidden;
            margin-bottom: 16px; /* 从12px增加到16px，增加与名称之间的间距 */
            border: 2px solid #ebeef5;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          
          .blogger-details {
            text-align: center;
            width: 100%;
            
            .blogger-name {
              font-size: 18px;
              font-weight: 600;
              margin: 0 0 8px; /* 从4px增加到8px，增加与简介之间的间距 */
              color: #303133;
            }
            
            .blogger-bio {
              font-size: 14px;
              color: #606266;
              margin: 0 0 12px;
              line-height: 1.4;
            }
            
            .blogger-divider {
              width: 80%;
              height: 1px;
              background-color: rgba(0, 0, 0, 0.05);
              margin: 15px auto;
            }
            
            .blogger-stats {
              display: flex;
              justify-content: center;
              gap: 30px;
              margin-top: 5px; /* 从20px减少到5px，因为已经有分隔线和margin */
              width: 100%;
              margin-bottom: 0;
              
              .stats-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                min-width: 36px; /* 确保有足够的宽度容纳数字 */
                
                .stats-number {
                  font-size: 22px; /* 从28px减小到22px，为大数字节省空间 */
                  font-weight: bold;
                  color: #409EFF;
                  line-height: 1;
                  margin-bottom: 5px;
                  white-space: nowrap; /* 防止数字换行 */
                }
                
                .stats-label {
                  font-size: 12px;
                  color: #909399;
                  line-height: 1;
                }
              }
            }
          }
        }
      }
      
      .filter-card {
        .filter-header {
          border-bottom: 1px solid #ebeef5;
          padding-bottom: 10px;
          margin-bottom: 10px;
          
          .filter-title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            position: relative;
            padding-left: 10px;
            display: flex;
            align-items: center;
            
            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 14px;
              background-color: #409eff;
              border-radius: 1px;
            }
          }
        }
        
        .filter-content {
          padding: 0 5px;
          .filter-types, .filter-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 5px; /* 减小标签之间的间距 */
            margin-top: 10px;
            
            /* 修改标签样式，让标签默认为灰色，选中时为蓝色 */
            .filter-type-item, .filter-tag-item {
              cursor: pointer;
              margin: 0 0 5px; /* 减小底部边距 */
              padding: 0 10px;
              height: 22px;
              line-height: 20px;
              font-size: 12px;
              border-radius: 11px; /* 使标签更圆润 */
              transition: all 0.25s ease;
              background-color: rgba(240, 242, 245, 0.7);
              color: #606266; /* 默认文字颜色为灰色 */
              border-color: transparent;
              white-space: nowrap; /* 防止标签文本换行 */
              
              &.active, &.el-tag--dark {
                color: white;
                background-color: #409eff;
                border-color: transparent;
                box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
              }
              
              &:hover:not(.active):not(.el-tag--dark) {
                color: #409eff;
                background-color: rgba(64, 158, 255, 0.1);
                transform: translateY(-1px);
              }
            }
          }
          
          .filter-tags {
            max-height: 250px; /* 稍微减小高度 */
            overflow-y: auto !important;
            padding: 2px 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
            position: relative;
            z-index: 10;
            overscroll-behavior: contain;
            -webkit-overflow-scrolling: touch;
            touch-action: pan-y;
            scroll-behavior: smooth;
            will-change: transform;
            display: flex; /* 使用弹性布局替代网格 */
            flex-wrap: wrap; /* 允许换行 */
            gap: 5px; /* 保持原有间距 */
            align-items: flex-start;
            
            /* 隐藏滚动条但保持滚动功能 */
            &::-webkit-scrollbar {
              display: none;
            }
            
            /* 防止触摸设备上的滚动失效 */
            @media (pointer: coarse) {
              overflow-y: scroll !important;
              -webkit-overflow-scrolling: touch;
            }
          }
          
          .search-tip {
            font-size: 12px;
            color: #909399;
            margin-top: 5px;
            text-align: right;
          }
          
          .tag-search-input {
            margin-bottom: 10px;
            
            :deep(.el-input__inner) {
              height: 30px;
              line-height: 30px;
              border-radius: 15px;
              padding-left: 30px;
              font-size: 12px;
            }
            
            :deep(.el-input__prefix) {
              left: 10px;
            }
          }
        }
      }

      .contact-card {
        padding: 5px 10px;
        height: 70px;
        box-sizing: border-box;

        .contact-icons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          gap: 4px;

          .contact-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #606266;
            transition: all 0.25s ease;
            cursor: pointer;
            padding: 4px 6px;
            border-radius: 4px;

            svg {
              width: 18px;
              height: 18px;
            }

            &:hover {
              color: #409EFF;
              background-color: rgba(64, 158, 255, 0.1);
              transform: translateY(-2px);
            }
          }
        }
      }
    }
  }
}

// 媒体查询-适配移动设备
@media screen and (max-width: 768px) {
  .blog-home {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow-x: hidden; // 防止水平滚动
    
    .blog-header {
      height: 80px;
      
      .blog-header-content {
        height: 70px;
        justify-content: space-between;
        padding: 0 15px;
        display: flex;
        align-items: center; /* 添加垂直居中对齐 */
        
        .blog-info {
          padding-left: 5px;
          display: flex; /* 设置为flex布局 */
          flex-direction: column; /* 垂直排列 */
          justify-content: center; /* 垂直居中 */
          height: 100%; /* 确保高度撑满父容器 */
          
          .blog-title {
            font-size: 22px;
            margin-bottom: 2px;
            
            .crown-icon {
              left: -22px;
              top: -12px;
              font-size: 26px;
            }
          }
          
          .blog-subtitle {
            font-size: 12px;
            text-align: left;
            margin-top: 2px;
          }
        }
      }
      
      .blog-nav {
        display: none;
      }
    }
    
    // 移动端分类过滤栏样式
    .mobile-type-filter {
      position: fixed;
      top: 80px;
      left: 0;
      right: 0;
      z-index: 9;
      height: 40px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      .mobile-type-filter-scroll {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        padding: 0 15px;
        height: 100%;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
          display: none;
        }
        
        .mobile-type-item {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          height: 30px;
          margin: 5px 5px 5px 0;
          border-radius: 15px;
          font-size: 13px;
          background-color: rgba(0, 0, 0, 0.05);
          color: #606266;
          transition: all 0.3s;
          font-weight: 500;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          min-width: 50px;
          
          &:first-child {
            margin-left: 0;
          }
          
          &:last-child {
            margin-right: 10px;
          }
          
          &.active {
            color: white;
            background-color: #409EFF;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
            transform: translateY(-1px);
          }
          
          &:active {
            transform: translateY(1px);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
    
.blog-content {
      margin-top: 130px;
      display: flex; // 修复：需要是 flex 容器
      flex-direction: column;
      padding: 0;
      width: 100vw; // 使用视口宽度单位
      max-width: 100vw; // 使用视口宽度单位
      height: calc(100vh - 130px); // 确保有固定高度供 flex: 1 的子元素填充
      box-sizing: border-box;
      margin-left: 0;
      margin-right: 0;

      .article-cards {
        flex: 1 1 auto; // 填满父容器高度
        width: 100% !important; // 移动端占满，强制覆盖 PC 样式
        min-width: 0; // 允许收缩，防止内容撑开容器
        height: 100%; // 使用固定高度，让overflow生效
        padding: 0; // 移除可能的内边距
        margin: 0; // 移除可能的外边距
        box-sizing: border-box;
        max-width: 100%; // 移动端不受侧边栏约束
        overflow-y: auto; // 允许滚动
        
        .article-card-container {
          padding: 0 10px; // 将左右两侧的内边距都调整为10px
          box-sizing: border-box;
          width: 100%; // 确保容器宽度为100%
          margin: 0 auto; // 居中显示，消除右侧边缘
          
          .waterfall {
            grid-template-columns: 1fr;
            grid-gap: 15px;
            padding-right: 0; // 移除右侧额外内边距
            width: 100%;
            
            .article-card {
              height: auto; // 自适应高度
              min-height: 220px;

              .article-cover {
                height: 50px; // 装饰性色条高度（移动端）
              }

              .article-info {
                padding: 0 15px;

                .article-content {
                  flex: none;
                  padding: 10px 0;

                  .title-wrap {
                    height: 60px;
                    overflow: hidden;
                  }

                  .article-title {
                    font-size: 16px;
                    line-height: 30px;
                    margin: 0 0 10px 0;
                    word-break: break-all;
                    overflow-wrap: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }

                  .article-meta {
                    padding-left: 0;
                    margin-top: 10px;

                    .article-type {
                      margin-left: 0;
                    }
                  }
                }

                .article-divider {
                  margin: 6px 0;
                }

                .article-footer {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 0 0 4px;

                  .article-tags, .article-tags-placeholder {
                    min-height: 22px;
                    padding-left: 2px;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;

                    .article-tag {
                      margin: 0;
                      padding: 0 8px;
                    }
                  }

                  .read-more {
                    padding-right: 2px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
        
        // 统一有无文章时的页面显示样式
        .no-data {
          min-height: 300px;
          
          .no-data-content {
            padding: 30px 15px;
            
            i {
              font-size: 60px;
              margin-bottom: 15px;
            }
            
            .no-data-title {
              font-size: 18px;
              margin-bottom: 8px;
            }
            
            .no-data-tips {
              font-size: 13px;
              padding: 0 10px;
            }
          }
        }

        // 移动端列表视图
        .article-list-container {
          min-width: 0;
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 10px;
          box-sizing: border-box;
          overflow: visible;
          scrollbar-width: none;
          -ms-overflow-style: none;
          -webkit-overflow-scrolling: touch;
        }

        // 列表模式的到底提示放在 article-cards 内，用 IntersectionObserver 检测是否在视口
        .list-no-more {
          width: 100%;
          text-align: center;
          padding: 5px 0;
          opacity: 0 !important;
          transition: opacity 0.3s;

          &.visible {
            opacity: 1 !important;
          }

          span {
            color: #909399;
            font-size: 12px;
          }

          .copyright-info {
            text-align: center;
            .mobile-copyright {
              text-align: center;
              width: 100%;
              display: inline-block;
            }
          }
        }

          .article-list-empty {
            width: 100%;
            min-height: 300px;
            box-sizing: border-box;

            .no-data-content {
              width: 100%;
              padding: 30px 15px;
              box-sizing: border-box;

              i {
                font-size: 60px;
                margin-bottom: 15px;
              }

              .no-data-title {
                font-size: 18px;
                margin-bottom: 8px;
              }

              .no-data-tips {
                font-size: 13px;
                padding: 0 10px;
              }
            }
          }

        .article-list-item {
          margin-bottom: 10px !important;
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

          .list-item-type {
            width: 50px !important;
            min-height: 50px !important;

            .type-text {
              font-size: 13px;
              font-weight: 800;
              writing-mode: vertical-rl;
              text-orientation: mixed;
              letter-spacing: 4px;

              &.is-english {
                writing-mode: horizontal-tb;
                letter-spacing: 0;
              }
            }

            .type-views {
              font-weight: 700;

              &::before {
                content: '🔥';
                font-size: 10px;
              }
            }
          }

          .list-item-content {
              padding: 2px 12px;
              min-height: 60px;
              min-width: 0;
              overflow: hidden;
              width: 100%; // 强制占满可用宽度
              box-sizing: border-box;

              .list-item-row1 {
                display: flex;
                align-items: center;
                height: 30px;
                min-width: 0;
                overflow: hidden;
                margin-bottom: 2px;

                .list-item-title {
                  font-size: 14px;
                  line-height: 30px;
                  flex: 1;
                  min-width: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .list-item-views {
                  display: flex;
                  align-items: center;
                  gap: 2px;
                  font-size: 12px;
                  max-width: 50px;
                  white-space: nowrap;
                  justify-content: flex-end;

                  i {
                    font-size: 13px;
                  }
                }
              }

              .list-item-divider {
                width: 70%;
                height: 1px;
                margin: 2px auto;
                background: linear-gradient(
                  to right,
                  transparent 0%,
                  rgba(0, 0, 0, 0.1) 20%,
                  rgba(0, 0, 0, 0.1) 80%,
                  transparent 100%
                );
              }

              .list-item-row2 {
                margin-top: 2px;
                height: 22px;
                padding-bottom: 4px;

                .list-item-left {
                  gap: 6px;

                  .list-item-badge {
                    width: 18px;
                    height: 18px;

                    i {
                      font-size: 10px;
                    }
                  }

                  .list-item-tags {
                    gap: 4px;

                    .list-tag {
                      padding: 0 6px;
                      height: 18px;
                      line-height: 16px;
                      font-size: 10px;
                    }
                  }
                }

                .list-item-right {
                  gap: 6px;
                  margin-left: 8px;

                  .list-item-date {
                    font-size: 11px;
                  }
                }
              }
            }
          }
        }
    }

    .filter-panel {
        display: none;
      }
    }

    /* 移动端到底提示样式 */
    .blog-home .blog-content .article-cards .article-end-tip {
      text-align: center;
      padding: 10px 0;
      opacity: 1 !important;
      visibility: visible !important;

      span {
        color: #909399 !important;
        font-size: 12px;
      }

      .copyright-info {
        text-align: center;
        margin-top: 8px;

        .pc-copyright {
          display: none;
        }

        .mobile-copyright {
          display: inline-block;
          text-align: center;
          font-size: 11px;
          color: #909399;
        }
      }
    }

    /* 移动端按钮组的样式 */
    .mobile-action-buttons {
      position: fixed !important;
      right: 15px !important;
      bottom: 80px !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 15px !important;
      z-index: 2001 !important;
      
      .mobile-icon-btn {
        width: 40px !important;
        height: 40px !important;
        border-radius: 40px !important;
        background-color: rgba(255, 255, 255, 0.7) !important;
        color: #409eff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 0 !important;
        transition: all 0.3s ease !important;
        
        i {
          font-size: 20px !important;
        }
        
        &:hover, &:focus {
          background-color: rgba(255, 255, 255, 0.9) !important;
          transform: scale(1.05) !important;
        }
        
        &:active {
          background-color: rgba(255, 255, 255, 1) !important;
          transform: scale(0.95) !important;
        }
      }
    }
    
    /* 统一移动端按钮包装器样式 */
    .mobile-btn-wrapper {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 40px !important;
      height: 40px !important;
    }

    /* 确保移动端背景设置按钮包装器正确显示 */
    .mobile-bg-settings-wrapper {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 40px !important;
      height: 40px !important;
      z-index: 2001 !important;
    }
  }
  
  /* 移动端导航菜单相关样式保持不变 */
  .mobile-nav-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    background: rgba(255, 255, 255, 0.95);
    z-index: 99;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    
    &.active {
      transform: translateX(0);
    }
    
    .mobile-nav-header {
      padding: 20px 15px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      .mobile-blogger-info {
        display: flex;
        align-items: center;
        
        .mobile-blogger-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 15px;
          border: 2px solid #ebeef5;
          
          img {
      width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        
        .mobile-blogger-details {
          .mobile-blogger-name {
            font-size: 16px;
            font-weight: 600;
            margin: 0;
            color: #303133;
          }
          
          .mobile-blogger-bio {
            font-size: 12px;
            color: #606266;
            margin: 5px 0 0;
          }
        }
      }

      .mobile-contact-icons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;

        .mobile-contact-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #606266;
          transition: all 0.25s ease;
          cursor: pointer;
          padding: 6px;
          border-radius: 4px;

          &:hover {
            color: #409EFF;
            background-color: rgba(64, 158, 255, 0.1);
            transform: translateY(-2px);
          }
        }
      }
    }
    
    .mobile-nav-search {
      padding: 15px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .mobile-nav-tags {
      padding: 15px;
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      
      &::-webkit-scrollbar {
        display: none; // 隐藏滚动条
      }
      
      .mobile-nav-section-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        position: relative;
        padding-left: 10px;
        
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 14px;
          background-color: #409eff;
          border-radius: 1px;
        }
      }
      
      .mobile-tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 20px;
        
        .mobile-tag-item {
          cursor: pointer;
          padding: 0 12px;
          height: 24px;
          line-height: 22px;
          font-size: 12px;
          border-radius: 12px;
          transition: all 0.25s ease;
          background-color: rgba(240, 242, 245, 0.7);
          color: #606266;
          border-color: transparent;
          margin: 0;
          
          &.active {
            color: white;
            background-color: #409eff;
            border-color: transparent;
            box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
          }
          
          &:hover:not(.active) {
            color: #409eff;
            background-color: rgba(64, 158, 255, 0.1);
            transform: translateY(-2px);
          }
        }
      }
    }

        }

    .mobile-nav-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 98;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    
    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
  
  /* 暗色模式下移动端按钮样式 */
  .mobile-action-buttons .mobile-icon-btn {
    background-color: rgba(30, 30, 30, 0.5) !important;
    color: #67b3fd !important;
    
    &:hover, &:focus {
      background-color: rgba(40, 40, 40, 0.8) !important;
    }
    
    &:active {
      background-color: rgba(50, 50, 50, 0.9) !important;
    }
  }

// 确保PC版本显示正常
@media screen and (min-width: 769px) {
  .mobile-nav-menu,
  .mobile-nav-backdrop,
  .mobile-type-filter,
  .mobile-action-buttons {
    display: none;
  }
  
  .blog-content {
    .filter-panel {
      display: block;
    }
  }
}

// 添加no-data-tips样式
.no-data-tips {
  margin-top: 10px;
  font-size: 14px;
  color: #909399;
  text-align: center;
}

/* 添加版权信息样式 */
.copyright-info {
  text-align: center;
  padding: 5px 0;
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
  flex-shrink: 0;
  
  .pc-copyright {
    display: inline;
  }

  .mobile-copyright {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .blog-home {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow-x: hidden; // 防止水平滚动
    
    // ... existing code ...
    
    /* 移动端版权信息样式 */
    .copyright-info {
      text-align: center !important;
      width: 100% !important;
      
      .pc-copyright {
        display: none;
      }
      
      .mobile-copyright {
        display: inline-block;
        text-align: center !important;
        width: 100% !important;
      }
    }
    
    // ... existing code ...
  }
  
  // ... existing code ...
}

/* 背景设置对话框样式 */
:deep(.bg-settings-dialog) {
  /* 这部分样式将由BackgroundSettings组件提供 */
}

/* 自定义文章卡片的tooltip样式 */
:global(.article-card-container .el-tooltip__popper) {
  font-size: 16px !important;
  padding: 8px 12px !important;
}
</style> 

<!-- 添加全局样式 -->
<style>
.el-tooltip__popper.is-dark {
  font-size: 16px;
  padding: 8px 12px;
  line-height: 1.4;
}

/* 博客页面特定的全局样式，覆盖App.vue中的移动端样式 */
.blog-page-container .mobile-menu-btn {
  display: none !important; /* 强制隐藏App.vue中的移动端菜单按钮 */
}

.mobile-bg-settings-wrapper .bg-settings-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 40px !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409eff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  position: static !important;
  top: auto !important;
  right: auto !important;
}

@media (prefers-color-scheme: dark) {
  .mobile-bg-settings-wrapper .bg-settings-btn {
    background-color: rgba(30, 30, 30, 0.7) !important;
    color: #67b3fd !important;
  }

  .mobile-bg-settings-wrapper .bg-settings-btn:hover,
  .mobile-bg-settings-wrapper .bg-settings-btn:focus {
    background-color: rgba(40, 40, 40, 0.9) !important;
  }

  .mobile-bg-settings-wrapper .bg-settings-btn:active {
    background-color: rgba(50, 50, 50, 1) !important;
  }
}

/* 加密文章遮罩样式（已移除） */</style> 
